/**
 * Logs an error message to the console and throws an Error with the same message.
 * This function is designed to provide consistent error handling by ensuring errors
 * are both logged and thrown.
 *
 * @param message - The error message to log and include in the thrown Error
 * @throws {Error} Always throws an Error with the provided message
 * @returns {never} This function never returns as it always throws
 */
export function logAndThrowError(message) {
    console.warn(`[Error]: ${message}`);
    throw new Error(message);
}
